<template>
  <div class="main-wrapper">
    <div>
      <layout-header></layout-header>
      <breadcrumb2></breadcrumb2>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar></sidebar>
            </div>
            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>
            <div class="col-md-7 col-lg-8 col-xl-9" v-else>
              <div class="row ml-md-3">
                <div class="col-12">
                  <button class="new_btn btn btn-primary btn-sm" data-toggle="modal" @click="
                    $bvModal.show('add_new_patient');
                  " href="">Add New Patient</button>
                   <!-- add_new_patient(item); -->
                </div>
              </div>
              <div class="row row-grid ml-md-3 mt-2">
                <div class="col-md-6 col-lg-4 col-xl-3">
                  <input type="text" v-model="update_patient.patient" class="form-control mt-1"
                    placeholder="Patient Name" oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '');"
                    @input="my_patients" />
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                  <input type="text" class="form-control mt-1" v-model="update_patient.mobile_no" placeholder="Mobile"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '');" @input="my_patients"/>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                  <input type="text" class="form-control mt-1" v-model="update_patient.city" placeholder="City"
                    oninput="this.value = this.value.replace(/[^a-zA-Z]/g, '');" @input="my_patients" />
                </div>
              </div>
              <div class="row row-grid mt-4 ml-md-3" id="patient_container">
                <div class="col-md-6 col-lg-4 col-xl-4" v-for="(item, index) in patient" v-bind:key="index" :key="index"
                  v-show="setPaginate(index)">
                  <div class="profile-widget text-center">
                    <div class="profile-info-widget">
                      <a href="javascript:void(0);" class="booking-doc-img">
                        <img v-bind:src="item.image
                          ? config.base_url_for_Image + item.image
                          : loadImg('Patient Profile.svg')
                          " alt="User Image"
                          @click="item.last_encounter !== null && item.last_appointment !== null ? handleClick(item) : null"
                          style="border-radius: 50%;" />
                      </a>
                      <div class="profile-det-info">
                        <h3>
                          <a href="javascript:void(0);"
                            @click="item.last_encounter !== null && item.last_appointment !== null ? handleClick(item) : null">
                            {{ item.patient_name }}
                          </a>
                        </h3>

                        <div class="patient-details">
                          <h5 class="mb-0 mt-3">
                            <i class="fas fa-map-marker-alt"></i>
                            {{ item.city }},
                            {{ item.state }}
                          </h5>
                        </div>
                        <div class="patient-details mt-3">
                          <h5 class="mb-0">
                            <i class="fas fa-phone"></i>
                            {{ item.mobile }}
                          </h5>
                        </div>
                        <a class="
                           btn btn-sm bg-success-light mt-3" data-toggle="modal" @click="
                            $bvModal.show('Add_Investigation_modal'); book_appointments(item);
                          " href="">
                          Book appointment</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h5 v-if="patient.length === 0 && !showspinner" style="margin-left: -8%" class="No_data">
                No Patient Found
              </h5>
              <!-- pagination start -->
              <div class="row justify-content-center" v-if="patient.length > 12">
                <div>
                  <h5 class="" style="color: #8d8c8c;">Total Patient : {{ total_patient }}</h5>
                </div>
              </div>
              <div id="pagination" v-if="patient.length > 12">
                <ul class="pagination justify-content-center">
                  <!-- "Previous" Button -->
                  <li class="page-item" :class="current === 1 ? 'disabled' : ''">
                    <a href="#" class="page-link" aria-label="Previous"
                      @click.prevent="updateInvestigationCount(current - 1)">
                      Previous
                    </a>
                  </li>

                  <!-- Pagination Links (Display 5 at a time) -->
                  <li v-for="page_index in paginate_total" :key="page_index.id" :class="[
                    'page-item',
                    current === page_index ? 'active' : ''
                  ]" v-if="page_index >= current - 2 && page_index <= current + 2">
                    <a href="#" class="page-link" @click.prevent="updateInvestigationCount(page_index)">
                      {{ page_index }}
                    </a>
                  </li>

                  <!-- "Next" Button -->
                  <li class="page-item" :class="current === paginate_total ? 'disabled' : ''
                    ">
                    <a href="#" class="page-link" aria-label="Next"
                      @click.prevent="updateInvestigationCount(current + 1)">
                      Next
                    </a>
                  </li>
                </ul>
              </div>
              <!-- pagination end -->
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
    <!-- book appointment modal -->
    <div>
      <b-modal id="Add_Investigation_modal" hide-footer>
        <!-- <template #modal-title> -->
        <template #modal-title>
          <h3 class="modal-title">Book Appointment</h3>
        </template>
        <div class="d-block text-center">
          <div class="card">
            <div class="card-body">
              <div class="modal-body">
                <div class="row form-row">
                  <div class="col-12 col-md-6">
                    <h5 class="text-left">Select Hospital</h5>
                    <div class="form-group" v-if="count !== 1">
                      <v-select name="hospital_name" required="" label="hospital_name" placeholder="Select Hospital"
                        @input="onChangeHospital" :reduce="(option) => option.hospital" :options="hospitals">
                      </v-select>
                    </div>
                    <div v-else>
                      <input type="text" class="form-control" :value="hospitals[0].hospital_name" disabled
                        style="background-color: #fff;">
                    </div>

                    <!-- 
                    <v-select class="pb-2" name="hospital_name" required="" label="hospital_name"
                      placeholder="Select Hospital" @input="onChangeHospital" :reduce="(option) => option.hospital"
                      :options="hospitals">
                    </v-select> -->
                  </div>
                  <div class="col-12 col-md-6">
                    <h5 class="text-left">Select Appointment Date</h5>
                    <!-- <div class="bookingrange btn btn-white btn-sm">
                      <VueDatePicker v-model="selected_date" placeholder="Choose date" color="#15558d"
                        :minDate="disabledDates" @onChange="get_slots" style="width:235px; height:27px;" />
                    </div> -->
                    <div class="bookingrange btn btn-white btn-sm mb-1" style="width: 100%;">
                      <VueDatePicker v-model="selected_date" placeholder="Choose date" color="#15558d"
                        :minDate="disabledDates" @onChange="get_slots" />
                    </div>
                  </div>

                  <div class="col">
                    <div class="form-group">
                      <div class="card booking-schedule schedule-widget" v-if="selected_object != undefined">
                        <!-- Schedule Header -->
                        <div class="schedule-header">
                          <div class="row">
                            <div class="col-md-12">
                              <!-- Day Slot -->
                              <div class="day-slot" v-if="schedule_days.length > 0">
                                <ul v-if="selected_object != undefined">
                                  <li v-for="(day, index) in schedule_days" :key="index" @click="change_date(day)"
                                    :class="{ 'active-day': activeDay === day.day, 'selected-date': getDateForDay(day.day).fullDate === selected_date }">
                                    <div>
                                      <span style="font-size:13px;" class="slot_day">{{ day.day.substring(0, 3)
                                        }}</span>
                                      <span style="font-size:11px;" class="slot-date">{{ getDateForDay(day.day).dateStr
                                        }}</span>
                                    </div>
                                  </li>

                                </ul>
                              </div>
                              <!-- /Day Slot -->
                            </div>
                          </div>
                        </div>
                        <!-- /Schedule Header -->
                        <div class="schedule-cont" v-if="slots != undefined">
                          <div class="row">
                            <div class="col-md-12">
                              <!-- Time Slot -->
                              <div class="time-slot">
                                <ul class="text-left m-1">
                                  <li>Slot Number and Estimated Time</li>
                                </ul>
                                <ul class="clearfix">
                                  <li v-for="(slot, index) in slots" :key="index">
                                    <a :id="slot.name" class="timing" :class="active_slot === index ? 'active' : ''"
                                      @click="set_slot(slot, index)" :disabled="slot.booked">
                                      <span class="slot_number">{{ slot.slot_no }}</span>
                                      <br />
                                      <span>{{ slot.from_time.slice(0, 5) }}</span>

                                      <!-- Add this line to display the slot number -->
                                    </a>
                                  </li>
                                </ul>
                              </div>
                              <!-- /Time Slot -->
                            </div>
                          </div>
                        </div>
                        <div v-else class="mt-2" style="color:black;">
                          {{ not_data }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-12">
                    <div class="text-center mt-4">
                      <div class="submit-section text-left"
                        v-if="selected_object != undefined && selected_slot != undefined">
                        <button type="submit" id="medical_btn" class="btn btn-primary submit-btn" data-dismiss="modal"
                          aria-label="Close" :disabled="disabled" @click="Booking_Appointment()">
                          Book Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <!-- book appointment modal end -->

    <!-- new patient add modal -->
    <div>
      <b-modal id="add_new_patient" hide-footer @hidden="resetAddNewPatientModal">
        <!-- <template #modal-title> -->
        <template #modal-title>
          <h3 class="modal-title">Add New Patient</h3>
        </template>
        <div class="d-block text-center">
          <div class="card">
            <div class="card-body">
              <div class="modal-body">
                <div class="row form-row" v-if="!showOtpInput">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <input type="text" name="first_name" required class="form-control floating"
                        v-model="register_patient.first_name" placeholder="First Name"
                        oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <input type="text" name="last_name" required class="form-control floating"
                        v-model="register_patient.last_name" placeholder="Last Name"
                        oninput="this.value = this.value.replace(/[^a-zA-Z]/g, '');" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group" style="position: relative;">
                      <button class="btn btn-default" type="button"
                        style="position: absolute; left: 0; top: 0; border: 1px solid #ccc; border-right: none; background-color: lightgrey; height: 40px; border-radius: 4px 0 0 4px; z-index: 2;">91</button>
                      <input type="text" required maxlength="10" minlength="10" @keypress="onlyNumber"
                      @input="validateAlternateNumber"
                        v-model="register_patient.patient_mobile_no" class="form-control floating"
                        placeholder="Mobile Number" @keydown.enter.prevent="$refs.sendOtpButton.click()"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                        style="padding-left: 60px; padding-top: 10px; padding-bottom: 10px; border-radius: 4px; letter-spacing: 2px;" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <v-select name="city" required="" label="city" placeholder="Select City"
                        v-model="register_patient.city" :reduce="(option) => option.city" :options="cities">
                      </v-select>
                    </div>
                  </div>
                  <div class="col-12 col-md-12">
                    <div class="text-center mt-2">
                      <div class="submit-section text-left">
                        <button type="submit" id="medical_btn" class="btn btn-primary submit-btn" data-dismiss="modal"
                          aria-label="Close" @click="New_Patient_add()">
                          Send OTP
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="col-md-12 col-lg-12">
                  <div class="login-header">
                    <h3 class="text-center">Enter OTP</h3>
                    <!-- <p class="small text-muted">Enter your OTP No</p> -->
                  </div>

                  <!-- Forgot Password Form -->
                  <div id="app">
                    <div class="otp-container">
                      <input v-for="(value, index) in otpValues" :key="index" type="text" maxlength="1"
                        class="otp-input" :value="value" @input="handleInput(index, $event.target.value)"
                        @keydown.backspace="handleBackspace(index)" ref="otpFields" @keypress="onlyNumber"
                        @keydown.enter.prevent="verify_OTP()" pattern="[0-9]*" autofocus />
                    </div>
                    <div class="mt-3 text-center">
                      <div v-if="!showResendButton">
                        <p>Resend OTP in: {{ countdown }} seconds</p>
                      </div>
                      <div v-else>
                        <button class="btn btn-link" @click="resendOtp">Resend OTP</button>
                      </div>
                    </div>
                  </div>

                  <div class="mt-5">
                    <button ref="verifyOtpButton" class="btn btn-primary login-btn" type="submit" @click="verify_OTP()">
                      Verify OTP
                    </button>
                  </div>
                  <!-- /Forgot Password Form -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <!-- new patient add modal end -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import CommonApi from "../../../services/CommonApi";
import config from "../../../services/CommonApi";
const images = require.context("@/assets/img/patients");
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";
import axios from "axios";
export default {
  data() {
    return {
      countdown: 60,
      showResendButton: false,
      countdownInterval: null,

      otpValues: ["", "", "", "", "", ""],
      activeDay: "",
      count: 0,
      patient: [],
      total_patient: 0,
      cities: [],
      states: [],
      hospitals: [],
      last_encounter: [],
      showspinner: true,
      config: config,
      todays_date: new Date(),
      selected_date: undefined,
      disabledDates: new Date(),
      slot_no: "",
      slots: undefined,
      selected_slot: undefined,
      active_slot: undefined,
      format: "dd-MM-yyyy",
      selected_hospital: "",
      active_slot: undefined,
      schedule_days: [],
      appointment_type: "",
      selected_object: undefined,
      current: 1,
      paginate: 12,
      paginate_total: 0,
      new_hospital: "",
      not_data: "",
      register_patient: {
        doctor_mobile_no: "",
        first_name: "",
        last_name: "",
        patient_mobile_no: "",
        city: "",
      },
      showOtpInput: false,

      book_appointment: {
        hospital: "",
        patient: "",
        practitioner: this.$store.state.user.user_id,
        service_unit: "",
        appointment_id: "",
        appointment_date: "",
        appointment_time: "",
        appointment_type: "",
      },

      update_patient: {
        state: "",
        patient: "",
        city: "",
        mobile_no: ""
      }
    };
  },
  computed: {

    isOtpValid() {
      return this.otp.every((digit) => /\d/.test(digit)); // Check if all digits are numbers
    },

    isHospitalFieldDisabled() {
      // Check if the count is 1 and the selected_hospital is empty
      return this.count === 1 && !this.selected_hospital;
    },
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),

    currentDay() {
      const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const today = new Date().getDay(); // Get the current day of the week (0-6)

      return daysOfWeek[today];
    },
    reschedule_validation() {
      return (
        this.book_appointment.appointment_date &&
        this.book_appointment.appointment_time
      );
    },
  },
  watch: {

    selected_date(newDate) {
      if (newDate) {
        this.get_slots();
      }
    },
    count(newCount) {
      if (newCount === 1 && this.hospitals.length > 0) {
        this.selected_hospital = this.hospitals[0].hospital;
      }
    },
    reschedule_validation() {
      if (
        this.book_appointment.appointment_date === "" ||
        this.book_appointment.appointment_time === ""
      ) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
    fake_appointments_details: {
      handler() {
        if (this.download) {
          setTimeout(this.generateReport(), 2000);
        }
      },
      deep: true,
    },
  },


  mounted() {

    let user = localStorage.getItem("userInfo");
    if (!user) {
      this.$router.push({ name: 'login' })
    }
    this.get_doctor_details()
    this.my_patients();
    this.get_cities();
    this.fetchAvailabilityDays();
    this.get_practitioner_service_unit_hospital();
    this.get_appointment_type();
    this.selected_date = moment().format("YYYY-MM-DD");

    $("#booking-from").datetimepicker({
      format: "DD/MM/YYYY",
      icons: {
        up: "fas fa-chevron-up",
        down: "fas fa-chevron-down",
        next: "fas fa-chevron-right",
        previous: "fas fa-chevron-left",
      },
    });
  },

  components: { VueDatePicker },

  methods: {

    validateAlternateNumber(event) {
    const value = event.target.value;
    if (value.length > 0 && parseInt(value.charAt(0)) < 6) {
      this.$swal.fire({
        icon: "warning",
        title: "Invalid Number",
        text: "The number must start with 6 or higher.",
      });
      this.register_patient.patient_mobile_no = "";
    }
  },

    startCountdown() {
      this.countdown = 60;
      this.showResendButton = false;
      clearInterval(this.countdownInterval);
      this.countdownInterval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1;
        } else {
          this.showResendButton = true;
          clearInterval(this.countdownInterval);
        }
      }, 1000);
    },
    resendOtp() {
      const bodyFormData = new FormData();
      bodyFormData.append("phone", `91${this.register_patient.patient_mobile_no}`);
      CommonApi.post_data("sahaj.api.send_otp", bodyFormData, true).then((res) => {
        if (res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
          });
          this.startCountdown();
        } else {
          this.$swal.fire({
            icon: "warning",
            title: "Warning",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },

    resetAddNewPatientModal() {
      this.register_patient = {
        doctor_mobile_no: "",
        first_name: "",
        last_name: "",
        patient_mobile_no: "",
        city: "",
      };
      this.showOtpInput = false;
      this.otpValues = ["", "", "", "", "", ""];
    },

    handleInput(index, value) {
      if (value.length > 1) {
        return;
      }
      this.otpValues[index] = value;
      if (value.length === 1 && index < this.otpValues.length - 1) {
        this.$refs.otpFields[index + 1].focus();
      }
    },
    handleBackspace(index) {
      if (this.otpValues[index] !== "") {
        this.otpValues[index] = "";
      } else if (index > 0) {
        this.$refs.otpFields[index - 1].focus();
      }
    },


    beforeDestroy() {
    clearInterval(this.countdownInterval);
  },

    async New_Patient_add() {
      if (this.register_patient) {
        var bodyFormData = new FormData();
        bodyFormData.append("phone", `91${this.register_patient.patient_mobile_no}`);
        CommonApi.post_data("sahaj.api.send_otp", bodyFormData, true).then(
          (res) => {
            if (res.status_code == 200) {
              this.showOtpInput = true;
              this.startCountdown();
              this.$swal.fire({
                icon: "success",
                title: "Success",
                text: res.message,
              });
              setTimeout(() => {
                this.$swal.close();
              }, 1000);
            } else {
              this.$swal.fire({
                icon: "warning",
                title: "Warning",
                text: res.message,
                showConfirmButton: true,
              });
            }
          }
        );
      }
    },

    verify_OTP() {
      const fullOtp = this.otpValues.join("");
      if (this.register_patient.patient_mobile_no && fullOtp) {
        this.$swal({
          text: "Verifying OTP...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var bodyFormData = new FormData();
        bodyFormData.append("phone", `91${this.register_patient.patient_mobile_no}`);
        bodyFormData.append("otp", fullOtp);

        CommonApi.post_data("sahaj.api.verify_otp_code", bodyFormData, true).then((res) => {
          if (res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
            });
            this.register_Patient();
          } else {
            // OTP verification failed
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        });
      }
    },

    register_Patient() {
      this.$swal({
        text: "Creating your account",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      let data = {
        doctor_mobile_no: this.register_patient.doctor_mobile_no,
        first_name: this.register_patient.first_name,
        last_name: this.register_patient.last_name,
        patient_mobile_no: `91${this.register_patient.patient_mobile_no}`,
        city: this.register_patient.city,
      };

      CommonApi.post_data("sahaj.doctor_bot.register_patient_by_doctor_bot", data, true).then((res) => {
        if (res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },


    async get_cities() {
      this.selected_city = "";
      await CommonApi.get_data("sahaj.finalapi.get_city").then((res) => {
        this.cities = res.message;
      });
    },

    getDateForDay(dayOfWeek) {
      const today = moment();
      const currentDayOfWeek = today.format('dddd');
      const dayDifference = (moment().day(dayOfWeek).day() + 7 - moment().day(currentDayOfWeek).day()) % 7;
      const dateForDay = today.add(dayDifference, 'days').format("YYYY-MM-DD");

      return {
        dateStr: today.format("D MMM YY"), // Displayed date format
        fullDate: dateForDay // Full date format for comparison
      };
    },

    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    get_doctor_details() {
      const params = new URLSearchParams();
      params.append("name", this.user_id);
      CommonApi.get_data("sahaj.api.get_doctor_details", params).then((res) => {
        this.showspinner = false;
        if (res && res.data && res.status_code === 200) {
          this.register_patient.doctor_mobile_no = res.data.mobile_phone;
          console.log("ds",res.data.mobile_phone)
        }
      });
    },

    async fetchAvailabilityDays() {
      let search = new URLSearchParams({
        practitioner: this.user_id,
        hospital: this.new_hospital,
      });

      try {
        const res = await CommonApi.get_data(
          "sahaj.appointment.get_availability_days",
          search
        );

        if (res.data && res.data.length > 0) {
          this.schedule_days = res.data[0].schedule_days;
        } else {
          console.warn("No data returned for availability days");
        }
      } catch (error) {
        console.error("Error fetching availability days:", error);
      }
    },


    //pagination start
    updateInvestigationCount(i) {
      this.current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    setPaginate(i) {
      if (this.current == 1) {
        return i < this.paginate;
      } else {
        return (
          i >= this.paginate * (this.current - 1) &&
          i < this.current * this.paginate
        );
      }
    },
    //pagination end


    onChangeHospital(e) {
      this.selected_hospital = e;
      this.active_slot = undefined;
      if (e === null) {
        this.selected_object = undefined;
        this.selected_date = undefined;
      } else {
        if (this.selected_date) {
          this.get_slots();
        }
      }
    },


    async get_practitioner_service_unit_hospital() {
      let search = new URLSearchParams({
        practitioner: this.user_id,
      });

      try {
        const res = await CommonApi.get_data(
          "sahaj.appointment.get_practitioner_service_unit_hospital",
          search
        );

        if (res) {
          this.hospitals = res.data.hospitals;
          this.new_hospital = res.data.hospitals[0].hospital;
          this.count = res.data.count;

          // Call fetchAvailabilityDays after setting new_hospital
          await this.fetchAvailabilityDays();
        }
      } catch (error) {
        console.error("Error fetching practitioner service unit hospital:", error);
      }
    },

    async get_slots() {
      this.slots = undefined;
      this.active_slot = undefined;
      this.next_days = [];
      this.selected_object = new Date(this.selected_date);
      for (var i = 0; i <= 6; i++) {
        var currentDate = new Date(this.selected_date);
        currentDate.setDate(this.selected_object.getDate() + i);
        this.next_days.push(currentDate);
      }

      let search = new URLSearchParams({
        date: this.selected_date,
        // practitioner: this.doctor.name,
        practitioner: this.user_id,
      });
      await CommonApi.get_data(
        "sahaj.appointment.get_availability_data",
        search
      ).then((res) => {
        if (res.message !== "Not Available") {
          let slots = res.data.slot_details;
          this.slots = slots.find(
            (x) => x.hospital === this.selected_hospital
          ).avail_slot;
        }
        else {
          this.not_data = res.data
          // this.$swal.fire({
          //     icon: "warning",
          //     title: "Warning",
          //     text: res.message,
          //     showConfirmButton: true,
          //   });
        }
      });
    },


    get_moment(obj) {
      return moment(obj);
    },
    set_slot(slot, index) {
      this.selected_slot = slot;
      this.active_slot = index;
      $("a.timing").removeClass("selected");
      $("#" + slot.name).addClass("selected");
    },
    async change_date(day) {
      this.selected_slot = undefined;
      this.slots = undefined;
      this.active_slot = undefined;
      $("a.timing").removeClass("selected");

      // Get the current day of the week
      const today = moment();
      const currentDayOfWeek = today.format('dddd');

      // Get the selected day of the week
      this.activeDay = day.day;
      const selectedDayOfWeek = day.day;

      // Calculate the difference in days between the selected day and today
      const dayDifference = (moment().day(selectedDayOfWeek).day() + 7 - moment().day(currentDayOfWeek).day()) % 7;

      // Add the difference in days to the selected_date
      this.selected_date = today.add(dayDifference, 'days').format("YYYY-MM-DD");
      this.selected_object = day;

      let search = new URLSearchParams({
        date: this.selected_date,
        practitioner: this.doctor.name,
      });

      await CommonApi.get_data(
        "sahaj.appointment.get_availability_data",
        search
      ).then((res) => {
        let slots = res.data.slot_details;

        this.slots = slots.find(
          (x) => x.hospital === this.selected_hospital
        ).avail_slot;
      }
      )
    },

    /* Convert Appointment Date */
    convertAppointmentDate(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
      }
    },
    /* Convert Date */
    convertDate(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2);
        return [day, mnth, date.getFullYear()].join("-");
      }
    },
    /* Get time */
    convertTime(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          time =
            ("00" + date.getHours()).slice(-2) +
            ":" +
            ("00" + date.getMinutes()).slice(-2) +
            ":" +
            ("00" + date.getSeconds()).slice(-2);
        var H = +time.substr(0, 2);
        var h = H % 12 || 12;
        var ampm = H < 12 ? " AM" : " PM";
        var timeString = h + time.substr(2, 3) + ampm;
        return timeString;
      }
    },


    // add_new_patient(item) {
    //   this.patient_name = item.patient_name;
    //   this.book_appointment.patient = item.name;
    //   this.book_appointment.hospital = this.selected_hospital;
    // },

    book_appointments(item) {
      this.patient_name = item.patient_name;
      this.book_appointment.patient = item.name;
      this.book_appointment.hospital = this.selected_hospital;
      this.book_appointment.appointment_id = item.name;
      this.book_appointment.appointment_date = this.selected_date;
      this.book_appointment.appointment_time = this.selected_slot;
      this.book_appointment.slot_no = this.selected_slot;
    },

    Booking_Appointment() {
      if (!this.disabled) {
        const fromTime = this.selected_slot ? this.selected_slot.from_time : '';
        const slotNum = this.selected_slot ? this.selected_slot.slot_no : '';
        let data = {
          patient: this.book_appointment.patient,
          hospital: this.selected_hospital,
          appointment_type: this.appointment_type,
          practitioner: this.$store.state.user.user_id,
          patient: this.book_appointment.patient,
          appointment_date: this.selected_date,
          appointment_time: fromTime,
          slot_no: slotNum
        };
        CommonApi.post_data(
          "sahaj.finalapi.get_doctor_appointment",
          JSON.stringify(data)
        ).then((res) => {
          this.showspinner = false;
          if (res.status_code == 500) {
            const dateParts = this.selected_date.split('-');
            const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: `You already have an Open appointment with this Doctor on this date - ${formattedDate}`,
              showConfirmButton: true,
            });
          } else {
            const formattedTime = moment(this.selected_slot.from_time, 'HH:mm').format('hh:mm A');
            this.$swal.fire({
              icon: "success",
              title: "Appointment Booked Successfully!",
              text:
                "Appointment Booked with " +
                this.patient_name +
                " on " +
                this.get_moment(this.selected_object).format("D MMMM YYYY") +
                " " +
                formattedTime,
              showConfirmButton: true,
            }).then(() => {
              window.location.reload();
            });
          }
        });
      }
    },


    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    handleClick(item) {
      if (item.last_encounter === null && item.last_appointment === null) {
        // Do nothing or show a message to indicate that the button click is disabled
      } else {
        // Perform the desired action when the button is clicked
        this.navigatetoLastEncounter(
          item.name,
          item.last_appointment,
          item.last_encounter
        );
      }
    },

    // appointment type data

    async get_appointment_type() {
      await CommonApi.get_data("sahaj.api.get_appointment_type").then((res) => {
        if (res && res.data.length) {
          this.appointment_type = res.data[2].name;
        }
      });
    },

    /* Navigate to last Encounter  */
    navigatetoLastEncounter(patient_id, appointment_id, encounter_id) {
      this.$store.dispatch("user/closedAppointment", false);
      this.$router.push(
        `/doctor/update-patient-encounter/${patient_id}/${appointment_id}/${encounter_id}`
      );
    },


    /* Get Patient  */
    async my_patients() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      params.append("patient_name", this.update_patient.patient); // Replace with the actual patient name
      params.append("city", this.update_patient.city); // Replace with the actual city
      params.append("mobile_no", this.update_patient.mobile_no); // Replace with the actual mobile number

      await CommonApi.get_data("sahaj.api.my_patients", params).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.patient = res.data;
          this.total_patient = res.data.length;
          this.paginate_total = Math.ceil(
            this.patient.length / this.paginate
          );
        }
      });

      this.my_patients_with_last_encounter();
    },

    /* Get Last Encounter  */
    async my_patients_with_last_encounter() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.api.my_patients_with_last_encounter",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.message) {
          this.last_encounter = res.message;
        }
      });
      this.compareEncounter();
    },

    /* Compare patient Id and add last Encounter And Last Appointment  */
    compareEncounter() {
      this.patient.map((data) => {
        let index = this.last_encounter.findIndex(
          (item) => item.name === data.name
        );
        let last_encounter = this.last_encounter.find(
          (item) => item.name === data.name
        ).last_encounter;
        let last_appointment = this.last_encounter.find(
          (item) => item.name === data.name
        ).last_appointment;
        this.patient[index].last_encounter = last_encounter;
        this.patient[index].last_appointment = last_appointment;
      });
    },
  },
};
</script>

<style scoped>
.appointment-modal {
  display: block;
  text-align: center;
}

.appointment-modal-no-border {
  border: none !important;
}

.timing {
  cursor: pointer;
}

.active {
  background-color: #66CDAA !important;
  color: #fff !important;
}

.slot_number {
  background-color: #4682B4;
  color: #fff;
  padding-left: 6px;
  padding-right: 6px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 100%;
}

.rounded-brackets {
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #F8F8F8;
  border-radius: 50%;
  padding: 5px 10px;
  margin: 0 5px;
}

.active-item {
  color: #66CDAA;
}

.new_btn:hover {
  background-color: #008080;
}

.submit-btn:hover {
  background-color: #008080;
}

.submit-btn:active {
  background-color: #008080;
}

.active-day {
  color: #66CDAA !important;
}

body {
  height: 100%;
  width: 100%;
  background-color: #333;
}

.opt {
  text-align: center;
  letter-spacing: 15px;
}

#countdown {
  position: relative;
  margin: auto;
  margin-top: 8px;
  height: 40px;
  width: 40px;
  text-align: center;
}

#countdown-number {
  color: black;
  display: inline-block;
  line-height: 40px;
}

svg {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  transform: rotateY(-180deg) rotateZ(-90deg);
}

svg circle {
  stroke-dasharray: 113px;
  stroke-dashoffset: 0px;
  stroke-linecap: round;
  stroke-width: 2px;
  stroke: red;
  fill: none;
  animation: countdown 60s linear forwards;
}

.otp-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-input {
  width: 40px;
  height: 40px;
  text-align: center;
  font-size: 24px;
  margin: 0 10px;
  border: none;
  border-bottom: 2px solid #403636;
  box-shadow: none;
  background-color: transparent;
  color: #140b0b;
  transition: all 0.3s ease-in-out;
  font-family: Arial, Helvetica, sans-serif;
}

.otp-input:focus {
  outline: none;
  border-bottom: 2px solid #09e5ab;
}

.new_btn:hover {
  background-color: #008080;
}

@keyframes countdown {
  from {
    stroke-dashoffset: 0px;
  }

  to {
    stroke-dashoffset: 113px;
  }
}

.slot_day:hover {
  cursor: pointer;
}

.slot-date:hover {
  cursor: pointer;
}

.selected-date {
  color: #66CDAA;
  /* Or any color you prefer */
}
</style>



// WEBPACK FOOTER //
// src/components/kneexpert/doctor/MyPatients.vue